import { render, staticRenderFns } from "./modal-payment.vue?vue&type=template&id=7bf4cd46&scoped=true&"
import script from "./modal-payment.vue?vue&type=script&lang=js&"
export * from "./modal-payment.vue?vue&type=script&lang=js&"
import style0 from "./modal-payment.vue?vue&type=style&index=0&id=7bf4cd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4cd46",
  null
  
)

export default component.exports